import axios from 'axios';

const state = {
  cities: [],
};

const getters = {};

const actions = {
  async getCities({ commit }) {
    await axios
      .get(`${process.env.VUE_APP_API_ROOT}/cities`, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          Accept: 'application/json',
        },
      })
      .then((response) => {
        if (response.data.success) {
          commit('setCities', response.data.cities);
        }
      });
  },
};

const mutations = {
  setCities(st, cities) {
    st.cities = cities.sort((a, b) => (a.name > b.name ? 1 : -1));
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
